import { useContext, useEffect, useState, useCallback, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./utils/introTour.css";
import "./App.css";
import "shared/App.css";
import "intro.js/introjs.css";
import GlobalContext from "shared/GlobalContext";
// — all of these moved into shared/components/ except MainMenu & SideBar
import QlikObject from "shared/components/QlikObject";
import ConnectionLostModal from "shared/components/ConnectionLostModal";
import ControlSideBar from "shared/components/ControlSideBar";
import BookmarkListMenu from "shared/components/BookmarkListMenu";
import UserLoginLink from "shared/components/UserLogin";
import UserLogoutLink from "shared/components/UserLogout";
import Footer from "shared/components/Footer";
import useAuthenticatedUser from "shared/hooks/useAuthenticatedUser";
import GoogleAnalytics from "shared/components/GoogleAnalytics";
import applyURLSelections from "shared/utils/selectionsSupport";
import Routes from "./Routes";
import MainMenu from "./components/MainMenu";   // still site-specific
import SideBar from "./components/SideBar";     // still site-specific
// import applyURLSelections from "shared/utils/selectionsSupport"; // if needed later
import SurveyBlock from "@prozorro-sale/survey";
import "@prozorro-sale/survey/build/styles.css";



function App() {
  const { qlik, app} = useContext(GlobalContext);
  const [sessionClosed, setSessionClosed] = useState(false);
  const [siderBarOpened, setSideBarOpened] = useState(false);
  const authUser = useAuthenticatedUser();
  const navigate = useNavigate();

  const [menuLayout, setMenuLayout] = useState({
    HeaderTitle: "Prozorro.Продажі",
    FeedbackText: "Зворотній зв'язок",
    RequestAnalyticsText: "Замовити аналітику",
    MenuItem1: "Основні результати",
    MenuItem2: "Аукціони",
    MenuItem3: "Аналіз приватизації",
    MenuItem4: "Аналіз завершених торгів",
    MenuItem5: "Аналіз конкурентності",
    MenuItem6: "Динамiка показникiв",
    MenuItem7: "Монiторiнг перiодiв",
    MenuItem8: "Монiторiнг перiодiв приватизації",
    MenuItem9: "Учасники",
    MenuItem10: "Картка Учасника",
    MenuItem11: "Контракти",
    MenuItem12: "Питання",
    MenuItem13: "Майданчики",
    MenuItem14: "Організатори",
    MenuItem15: "Картка Організатора",
    MenuItem16: "Географiя",
    MenuItem17: "Найкращі результати",
    MenuItem18: "Відбори",
    MenuItem19: "Активи",
    MenuItem20: "Предмети продажу активiв",
    MenuItem21: "Об'єкти продажу приватизації",
    MenuItem22: "Динамiка торгiв",
    MenuItem24: "Перелік майна (оренда)",
    MenuItem25: "Договори оренди",
    MenuItem28: "Тип аукціону",
    MenuItem29: "Аналіз напрямків",
    MenuItem26: "Процедури землi",
    MenuItem27: "Втрати росії",
    MenuItem23: "Процедури дерева",
    MenuItem31: "Аналітика",
    MenuItem32: "Процедури оренди",
    MenuItem33: "Результати організатора",
    MenuItem34: "Процедури приватизації",
    MenuItem35: "NPS учасників аукціонів",
    MenuItem36: "Білінг дискваліфікованих учасників",
    MenuItem37: "Процедури розподілу квот",
    ConnectionLostTitle: "Підключення втрачено",
    ConnectionLostMessage:
      "Ваше підключення до Qlik Sense сервера втрачено, оновіть сторінку для продовження роботи.",
    ConnectionLostRefresh: "Оновити",
    Filters: "Фiльтри",
    Login: " ",
    isAppReady: false, // Add `isAppReady` to the initial state
  });

  const sidebarOverlayEl = useRef(null);

  const menuHandler = useCallback((e) => {
    e && e.preventDefault();
    if (document.body.classList.contains("sidebar-open")) {
      document.body.classList.remove("sidebar-open");
      document.body.classList.add("sidebar-closed");
    } else {
      document.body.classList.remove("sidebar-closed");
      document.body.classList.add("sidebar-open");
    }

    document.body.classList.toggle("sidebar-collapse");
  }, []);

  const closeMenuHandler = useCallback(
    (e) => {
      if (sidebarOverlayEl.current) {
        const overlayVisible =
          window.getComputedStyle(sidebarOverlayEl.current).display !== "none";
        if (overlayVisible) {
          menuHandler(e);
        }
      }
    },
    [menuHandler]
  );

  useEffect(() => {
    // applyURLSelections here to be able to navigate bookmark's page
    (async () => {
      await applyURLSelections(app, navigate);
    })();

    qlik.on("error", function (error) {
      if (
        error.method === "OnSessionClosed" ||
        error.method === "OnSessionTimedOut" ||
        error.message === "ProxyError.OnSessionTimedOut" ||
        error.message === "ProxyError.OnSessionClosed"
      ) {
        setSessionClosed(true);
      }
    });
  }, [qlik, app, navigate]);

  useEffect(() => {
    let menuItems;
    const createGeneric = async () => {
      menuItems = app.createGenericObject(
        {
          HeaderTitle: {
            qStringExpression: "=$(T(PZSHeader))",
          },
          FeedbackText: {
            qStringExpression: "=$(T(mshFeedbackLink))",
          },
          RequestAnalyticsText: {
            qStringExpression: "=$(T(mshButtonRequestAnalytics))",
          },
          MenuItem1: {
            qStringExpression: "=$(T(dashboardSheet))",
          },
          MenuItem27: {
            qStringExpression: "=$(T(lnkToWarApp))",
          },
          MenuItem2: {
            qStringExpression: "=$(T(auctionSheet))",
          },
          MenuItem3: {
            qStringExpression: "=$(T(shtPrivatizationAnalysis))",
          },
          MenuItem4: {
            qStringExpression: "=$(T(analysisSheet))",
          },
          MenuItem5: {
            qStringExpression: "=$(T(competitivenessSheet))",
          },
          MenuItem6: {
            qStringExpression: "=$(T(indicatorDynamicsSheet))",
          },
          MenuItem7: {
            qStringExpression: "=$(T(periodMonitorSheet))",
          },
          MenuItem8: {
            qStringExpression: "=$(T(shtPeriodMonitoringPrivatization))",
          },
          MenuItem9: {
            qStringExpression: "=$(T(tendererSheet))",
          },
          MenuItem10: {
            qStringExpression: "=$(T(tendererCardSheet))",
          },
          MenuItem11: {
            qStringExpression: "=$(T(contractSheet))",
          },
          MenuItem12: {
            qStringExpression: "=$(T(questionSheet))",
          },
          MenuItem13: {
            qStringExpression: "=$(T(ownerSheet))",
          },
          MenuItem14: {
            qStringExpression: "=$(T(organizerSheet))",
          },
          MenuItem15: {
            qStringExpression: "=$(T(organizerCardSheet))",
          },
          MenuItem16: {
            qStringExpression: "=$(T(geographySheet))",
          },
          MenuItem17: {
            qStringExpression: "=$(T(topSheet))",
          },
          MenuItem18: {
            qStringExpression: "=$(T(filtersSheet))",
          },
          MenuItem19: {
            qStringExpression: "=$(T(assetsSheet))",
          },
          MenuItem20: {
            qStringExpression: "=$(T(assetItemsSheet))",
          },
          MenuItem21: {
            qStringExpression: "=$(T(shtAssetsPrivatization))",
          },
          MenuItem22: {
            qStringExpression: "=$(T(incomeDynamicsSheet))",
          },
          MenuItem24: {
            qStringExpression: "=$(T(shtLRLeaseRegistry))",
          },
          MenuItem23: {
            qStringExpression: "=$(T(lnkToTimberApp))",
          },
          MenuItem26: {
            qStringExpression: "=$(T(lnkToLandApp))",
          },
          MenuItem25: {
            qStringExpression: "=$(T(shtLRLeaseContracts))",
          },
          MenuItem28: {
            qStringExpression: "=$(T(shtProcedureFormat))",
          },
          MenuItem29: {
            qStringExpression: "=$(T(shtDirectionsAnalysis))",
          },
          MenuItem31: {
            qStringExpression: "=$(T(Analytics))",
          },
          MenuItem32: {
            qStringExpression: "=$(T(lnkToLeaseApp))",
          },
          MenuItem33: {
            qStringExpression: "=$(T(shtOrganizerKPI))",
          },
          MenuItem36: {
            qStringExpression: "=$(T(mshp_disqualification_billing))",
          },
          MenuItem34: {
            qStringExpression: "=$(T(linkPrivatizationBI))",
          },
          MenuItem35: {
            qStringExpression: "=$(T(linkNPSBI))",
          },
          MenuItem37: {
            qStringExpression: "=$(T(mshp_renewablesLink))",
          },
          ConnectionLostTitle: {
            qStringExpression: "=$(T(ConnectionLostTitle))",
          },
          ConnectionLostMessage: {
            qStringExpression: "=$(T(ConnectionLostMessage))",
          },
          ConnectionLostRefresh: {
            qStringExpression: "=$(T(ConnectionLostRefresh))",
          },
          Filters: {
            qStringExpression: "=$(T(Filters))",
          },
          Login: {
            qStringExpression: "=Coalesce($(T(ttlLogin)), ' ')",
          },
          exportText: {
            qStringExpression: "=$(T(ttlExportTextProcess))",
          },
          exportCompletedText: {
            qStringExpression: "=$(T(ttlExportTextComplete))",
          },
          closeBtnText: {
            qStringExpression: "=$(T(ttlExportTextClose))",
          },
          ExportChartFootnote: {
            qStringExpression: "",
          },
          tourParamsNext: {
            qStringExpression: "=$(T(msh_tour_global_nextLabel))",
          },
          tourParamsPrev: {
            qStringExpression: "=$(T(msh_tour_global_prevLabel))",
          },
          tourParamsDone: {
            qStringExpression: "=$(T(msh_tour_global_doneLabel))",
          },
          tourParamsSkip: {
            qStringExpression: "=$(T(msh_tour_global_dontShowAgainLabel))",
          },
          tourGlobalNavbarTitle: {
            qStringExpression: "=$(T(msh_tour_global_navbar_title))",
          },
          tourGlobalNavbar: {
            qStringExpression: "=$(T(msh_tour_global_navbar))",
          },
          tourGlobalCurrentSelectionsTitle: {
            qStringExpression: "=$(T(msh_tour_global_current_selections_title))",
          },
          tourGlobalCurrentSelections: {
            qStringExpression: "=$(T(msh_tour_global_current_selections))",
          },
          tourGlobalBookmarkCreateTitle: {
            qStringExpression: "=$(T(msh_tour_global_bookmark_create_title))",
          },
          tourGlobalBookmarkCreate: {
            qStringExpression: "=$(T(msh_tour_global_bookmark_create))",
          },
          tourGlobalBookmarkShareTitle: {
            qStringExpression: "=$(T(msh_tour_global_bookmark_share_title))",
          },
          tourGlobalBookmarkShare: {
            qStringExpression: "=$(T(msh_tour_global_bookmark_share))",
          },
          tourGlobalFeedbackTitle: {
            qStringExpression: "=$(T(msh_tour_global_feedback_title))",
          },
          tourGlobalFeedback: {
            qStringExpression: "=$(T(msh_tour_global_feedback))",
          },
          tourGlobalAllFiltersTitle: {
            qStringExpression: "=$(T(msh_tour_global_filter_all_title))",
          },
          tourGlobalAllFilters: {
            qStringExpression: "=$(T(msh_tour_global_filter_all))",
          },
          tourHomePage: {
            qStringExpression: "=$(T(msh_tour_home_page))",
          },
          tourHomeHelpPopupTitle: {
            qStringExpression: "=$(T(msh_tour_home_help_popup_title))",
          },
          tourHomeHelpPopup: {
            qStringExpression: "=$(T(msh_tour_home_help_popup))",
          },
          tourHomeBarchartTitle: {
            qStringExpression: "=$(T(msh_tour_home_barchart_title))",
          },
          tourHomeBarchart: {
            qStringExpression: "=$(T(msh_tour_home_barchart))",
          },
          tourHomeBarchartSelection: {
            qStringExpression: "=$(T(msh_tour_home_barchart_selection))",
          },
          tourParamsOf: {
            qStringExpression: "=$(T(msh_tour_global_of))",
          },
          tourParamsTourStartButton: {
            qStringExpression: "=$(T(msh_tour_global_start_tour_button))",
          },
        },
        (reply) => {
          setMenuLayout((prevLayout) => ({
            ...prevLayout,
            ...reply,
            isAppReady: true,
          }));
        }
      );
    };
    createGeneric();
    return () => {
      if (menuItems && menuItems.qInfo) app.destroySessionObject(menuItems.qInfo.qId);
    };
  }, [app]);

  const sideBarOpenHandler = (e) => {
    e.preventDefault();
    setSideBarOpened(!siderBarOpened);
  };

  return (
    <>
      {sessionClosed && (
        <ConnectionLostModal
          title={menuLayout.ConnectionLostTitle}
          text={menuLayout.ConnectionLostMessage}
          refreshText={menuLayout.ConnectionLostRefresh}
        />
      )}

      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link pushmenu-btn"
              data-widget="pushmenu"
              href="/"
              role="button"
              onClick={menuHandler}
            >
              <i className="lui-icon lui-icon--menu"></i>
            </a>
          </li>
        </ul>

        <div className="form-inline">
          <h4 className="mb-0 prz-sale">{menuLayout.HeaderTitle}</h4>
        </div>

        <ul className="navbar-nav ml-auto d-flex align-items-center">
          <li className="nav-item jumpappfeedback">
            <a
              className="nav-link nav-link-black"
              href="https://docs.google.com/forms/d/e/1FAIpQLSfABoOsWy4wdAZ1m3wiCWwMAc12aDy3VFo3jIwxCcqvwRE89g/viewform"
              target="_blank"
              rel="noopener noreferrer"
            >
              📈 {menuLayout.RequestAnalyticsText}
            </a>
          </li>

          <li className="nav-item jumpappfeedback-mobile">
            <a
              className="nav-link nav-link-black"
              href="https://docs.google.com/forms/d/e/1FAIpQLSfABoOsWy4wdAZ1m3wiCWwMAc12aDy3VFo3jIwxCcqvwRE89g/viewform"
              target="_blank"
              rel="noopener noreferrer"
            >
              📈
            </a>
          </li>

          <li className="nav-item lang-btns">
            <QlikObject id="4a315040-e33f-4385-990e-c3d7bd9b7606" height="29px" showLoader={false} />
          </li>

          <li className="nav-item w-lang-mobile lang-btns-mobile">
            <QlikObject id="74ec601b-8e24-4ef5-947f-2b770d0ba42f" height="29px" showLoader={false} />
          </li>

          <li className="nav-item ">
            <a
              className={`nav-link tour-global-filterpane-dropdown ${
                siderBarOpened ? "active bg-light" : ""
              }`}
              href="/"
              role="button"
              onClick={sideBarOpenHandler}
            >
              <i className="lui-icon lui-icon--filterpane" />
              <span className="filters-txt">{menuLayout.Filters}</span>
            </a>
          </li>

          {!authUser.User || authUser.isAnonymous || sessionClosed ? (
            <>
              <UserLoginLink loginText={menuLayout.Login} />
            </>
          ) : (
            <>
              <BookmarkListMenu app={app} showBookmarkDetails={false} user={authUser} />
              <UserLogoutLink user={authUser} />
            </>
          )}
        </ul>
      </nav>

      <div className="main-header current-selections tour-global-current-selections">
        <QlikObject id="CurrentSelections" height="38px" showLoader={false} />
      </div>

      <aside className="main-sidebar sidebar-light-primary elevation-1">
        <Link to="/" className="brand-link">
          <img
            src={`${process.env.PUBLIC_URL}logo.png`}
            alt="Logo"
            className="brand-image"
          />
        </Link>

        <div className="sidebar tour-global-sidebar">
          <nav className="pt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column nav-child-indent"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              <MainMenu menuLayout={menuLayout} closeMenuHandler={closeMenuHandler} />
            </ul>
          </nav>
        </div>
      </aside>

      <div className="content-wrapper">
        <GoogleAnalytics id={process.env.REACT_APP_GA_ID}>
          <Routes menuLayout={menuLayout} />
        </GoogleAnalytics>
      </div>

      <ControlSideBar opened={siderBarOpened}>{siderBarOpened && <SideBar />}</ControlSideBar>

      <Footer />

      <div id="sidebar-overlay" ref={sidebarOverlayEl} onClick={menuHandler} />

      <SurveyBlock
        surveyId={"c584d5fe-1d59-405c-beb2-bc6e9229ad51"}
        surveyDomain={"auction.prozorro.sale"}
        surveyPublic={true}
        surveyLang={"uk_UA"}
      />
    </>
  );
}

export default App;
